module.exports = __webpack_public_path__ + "img/IMG_1990.67e7f081.jpg";